import React from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../assets/hafnia-logo.png";
import { useAuth } from "../../authProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import "./Header.css";

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const Header = () => {
  const { logout, account } = useAuth();
  const username = account?.username || account?.name || "";
  const stage = process.env.REACT_APP_STAGE;

  return (
    <header className="hdr">
      {/* Brand */}
      <div className="hdr__brand">
        <img className="hdr__logo" src={Logo} alt="Hafnia" />
        <span className="hdr__brand-name">
          Accounts Request Portal{stage && <span className="hdr__brand-env"> {stage.toLowerCase()}</span>}
        </span>
      </div>

      {/* Nav */}
      <nav className="hdr__nav">
        <NavLink
          to="/request"
          className={({ isActive }) =>
            "hdr__link" + (isActive ? " hdr__link--active" : "")
          }
        >
          Request
        </NavLink>
        <NavLink
          to="/history"
          className={({ isActive }) =>
            "hdr__link" + (isActive ? " hdr__link--active" : "")
          }
        >
          History
        </NavLink>

        <div className="hdr__divider" />

        <a
          href="/"
          className="hdr__logout"
          title="Sign out"
          onClick={async (e) => {
            e.preventDefault();
            await logout();
          }}
        >
          <span className="hdr__user-dot">{getInitials(username)}</span>
          {username}
          <FontAwesomeIcon icon={faRightFromBracket} style={{ opacity: 0.65, marginLeft: 2 }} />
        </a>
      </nav>
    </header>
  );
};

export default Header;

